import { getCreativeTemplateFieldsByTemplateMappingId } from "@/apis/v1/template";
import { TEMPLATE_FIELDS } from "@/modules/Asset/Template/template.constant";
import { TemplateDataValueApiResponse } from "@/modules/Asset/Template/template.interface";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

/**
 * Field values for one creative's template mapping.
 *
 * Moved out of `Template/template.hook.ts` in TS-1a, unchanged. Its only consumers are the two
 * Creative list rows, which render a `DisplayTemplate` preview from the result; moving it now
 * means TS-1b can delete `template.hook.ts` without touching them a second time.
 */
export function useTemplateFieldsByTemplateMappingId(args: {
  templateMappingId: number | null | undefined;
  queryParams?: {
    name?: string;
    type?: string;
  };
  // The old signature was `Record<any, any>`; the studio lints at 0 warnings, and neither
  // call site passes this today, so it is typed properly on the way across.
  options?: Omit<
    UseQueryOptions<TemplateDataValueApiResponse[]>,
    "queryKey" | "queryFn"
  >;
}) {
  const { templateMappingId, queryParams = {}, options = {} } = args;

  return useQuery<TemplateDataValueApiResponse[]>(
    TEMPLATE_FIELDS.withMappingId({ templateMappingId }),
    (context) =>
      getCreativeTemplateFieldsByTemplateMappingId(templateMappingId, context),
    {
      meta: {
        queryParams: { ...queryParams },
      },
      enabled: !!templateMappingId,
      ...options,
    }
  );
}
